import Block from './Block'
import gsap from 'gsap'
import store from '../util/store';

export default class KeyFigures extends Block {
  getElems() {
    this.container = this.el.querySelector('.b-keys-figures__list')
    this.keys = this.el.querySelectorAll('.b-key-figures__item-value .value')
  }

  init() {
    if (store.detect.isMobile) {
      this.keys.forEach((key) => {
        key.textContent = key.getAttribute('data-value')
      });
    } else {
      this.keys.forEach((key) => {
        const value = key.getAttribute('data-value')

        gsap.to(key, {
          scrollTrigger: {
            trigger: key
          },
          textContent: value,
          duration: 2,
          ease: 'power3.out',
          onUpdate: () => {
            key.textContent = Math.round(gsap.getProperty(key, 'textContent'))
          }
        })
      })
    }
  }
}
